import { Alert, Intent } from "@blueprintjs/core";

import { useCancelInviteClientScheduleMutation } from "@/graphql";

interface CancelBulkInviteScheduleProps {
  scheduleJobId: string;
  isOpen: boolean;
  onClose: () => void;
  afteCancelBulkInviteSchedule?: () => void;
  onSuccess?: () => void;
  onFail?: () => void;
}

function CancelBulkInviteSchedule({
  scheduleJobId,
  isOpen,
  onClose,
  onSuccess,
  onFail,
}: CancelBulkInviteScheduleProps) {
  const [cancelBulkInviteSchedule] = useCancelInviteClientScheduleMutation({
    onCompleted: (data) => {
      if (
        data &&
        data.cancelInviteClientSchedule &&
        data?.cancelInviteClientSchedule?.ok
      ) {
        onClose();
        onSuccess && onSuccess();
      } else {
        onClose();
        onFail && onFail();
      }
    },
    onError: () => {
      onClose();
      onFail && onFail();
    },
  });

  const confirmRemoveAssistant = () => {
    cancelBulkInviteSchedule({
      variables: {
        scheduleJobId: scheduleJobId,
      },
    });
  };

  return (
    <Alert
      cancelButtonText="Nevermind"
      confirmButtonText="Cancel"
      icon="trash"
      intent={Intent.DANGER}
      isOpen={isOpen}
      onCancel={onClose}
      onConfirm={confirmRemoveAssistant}
    >
      <p>Are you sure you want to cancel this scheduled invitation ?</p>
      Credit refunds will take time to process; please be patient.
    </Alert>
  );
}

export default CancelBulkInviteSchedule;
